import {UserStripeService} from "./service/UserStripeService";

import Components from "./components";
import {StripeService} from "./service/StripeService";

const rootDir = "app/stripe";

export default angular.module("tfApp.stripe", [Components(rootDir)])
                      .service(StripeService.id, StripeService)
                      .service(UserStripeService.id, UserStripeService)
                      .name;
